import { useState } from "react";
import useEvaApi, { EvaApiCall } from "../../../hooks/useEvaApi";
import MessagebirdConfigsPageView from "./MessagebirdConfigsPageView";
import useCustomEffect from "../../../hooks/useCustomEffect";

function MessagebirdConfigsPage() {
  const callEvaApi = useEvaApi();

  const [submitError, setSubmitError] = useState(null);
  const [messagebirdConfigData, setMessagebirdConfigData] = useState({
    api_key: "",
    originator: "",
    active: false,
  });

  /**
   * initialize the component
   */
  useCustomEffect(() => {
    fetchMessagebirdConfigData();
  });

  /**
   * This method will fetch the Messagebird config data from the API
   */
  async function fetchMessagebirdConfigData() {
    await callEvaApi(
      new EvaApiCall("integrations/messagebird/configs")
        .setLoadingGroup("messagebird_configs_page_fetch")
        .setOnSuccess((response) => {
          const newConfig = response.data.data;
          setMessagebirdConfigData({
            api_key: newConfig?.api_key || "",
            originator: newConfig?.originator || "",
            active: newConfig?.active || false,
          });
        })
    );
  }

  /**
   * This method will update the api key on input change
   * @param {event} e
   */
  function onApiKeyChange(e) {
    setMessagebirdConfigData({ ...messagebirdConfigData, api_key: e.target.value })
  }

  /**
   * This method will update the originator on input change
   * @param {event} e 
   */
  function onOriginatorChange(e) {
    setMessagebirdConfigData({ ...messagebirdConfigData, originator: e.target.value })
  }

  /**
   * This method will update the active status on toggle change
   * @param {boolean} value 
   */
  function onActiveChange(value) {
    setMessagebirdConfigData({ ...messagebirdConfigData, active: value })
  }
  
  /**
   * This method will submit the form
   */
  async function onSubmit() {
    await callEvaApi(
      new EvaApiCall("integrations/messagebird/configs")
        .setLoadingGroup("messagebird_configs_page_save")
        .setMethod("PUT")
        .setData(messagebirdConfigData)
        .setErrorState(setSubmitError)
        .setRedirectOnSuccess(true)
    );
  }

  return (
    <MessagebirdConfigsPageView 
      messagebirdConfigData={messagebirdConfigData}
      onApiKeyChange={onApiKeyChange}
      onOriginatorChange={onOriginatorChange}
      onActiveChange={onActiveChange}
      onSubmit={onSubmit}
      submitError={submitError}
    />
  );
}

export default MessagebirdConfigsPage;